// The eight scored risk categories, in display order. `key` is the
// compendium score field (logged-in views); `level` is the key in the public
// place summary's `levels` (GET /v1/public/places/:slug), which carries
// safety levels instead of scores.
export const RISK_CATEGORIES = [
    { key: "political_stability_score", level: "political_stability", icon: "bi-peace", label: "Political Stability" },
    { key: "crime_score", level: "crime", icon: "bi-slash-circle", label: "Crime Prevention" },
    { key: "cultural_sensitivity_score", level: "cultural_sensitivity", icon: "bi-person-raised-hand", label: "Cultural" },
    { key: "air_quality_score", level: "air_quality", icon: "bi-lungs", label: "Air Quality" },
    { key: "medical_care_score", level: "medical_care", icon: "bi-capsule", label: "Medical Care" },
    { key: "transportation_score", level: "transportation", icon: "bi-car-front-fill", label: "Transportation" },
    { key: "weather_score", level: "weather", icon: "bi-umbrella", label: "Weather" },
    { key: "environmental_score", level: "environmental", icon: "bi-radioactive", label: "Environmental" },
]

// Personal Safety is not scored yet; it always renders grey.
export const PERSONAL_SAFETY = { icon: "bi-person-bounding-box", label: "Personal Safety" }

// Same colours as colorCode(value, "hex"), keyed by level name.
export const LEVEL_COLORS = {
    Safe: "#198754",
    Okay: "#0dcaf0",
    Caution: "#ffc107",
    Danger: "#dc3545",
}

export const NO_DATA_COLOR = "#6c757d"
